export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON bear house CY.048ac219.png";